import { createContext } from "react";
const RiderContext = createContext({});

export default RiderContext;
